import { render } from "./JoinWaitlist.vue?vue&type=template&id=cdb44f88&scoped=true"
import script from "./JoinWaitlist.vue?vue&type=script&lang=js"
export * from "./JoinWaitlist.vue?vue&type=script&lang=js"

import "./JoinWaitlist.vue?vue&type=style&index=0&id=cdb44f88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdb44f88"]])

export default __exports__